import { HttpClient, HttpClientModule, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import Keycloak from 'keycloak-js';

@Injectable({
  providedIn: 'root'
})
export class AppKeycloakService {
  private keycloak: any;//Keycloak;

  constructor(private http:HttpClient) {

    
  }

  ina(){
    
  this.keycloak = new Keycloak({
      url: 'https://auth.suryojasvi.com/auth',//'http://localhost:8080/realms/master/account/',//'http://localhost:8080/', 
      realm: 'wyzminds',         // replace with your realm name
      clientId: 'wyzminds-auth'     // replace with your client ID
    });
  }

 async  init(): Promise<boolean> {

     this.keycloak = await new Keycloak({
      url: 'https://auth.suryojasvi.com/auth',//'http://localhost:8080/realms/master/account/',//'http://localhost:8080/', 
      realm: 'wyzminds',         // replace with your realm name
      clientId: 'wyzminds-auth'     // replace with your client ID
    });
    return await this.keycloak.init({
      onLoad:       'login-required',//'check-sso', //
      checkLoginIframe: false,
      // redirectUri: 'http://localhost:4200'
      //  silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html'
    })
  }

  spinLoading(hd:string = 'none')
  {
    let ngs:any = document.getElementById('nb-global-spinner');
    ngs.style.display = hd
  }


  login():Promise<any>
  {
    console.log("login => ", this.keycloak)
    return  this.keycloak.login({});
  }

  getTokenExpiration(token: string): Date | null {
  if (!token) return null;

  const payload = token.split('.')[1];
  const decoded = JSON.parse(atob(payload)); // base64 decode
  const exp = decoded.exp; // expiration timestamp (seconds)

  // Convert to milliseconds and return Date
  return new Date(exp * 1000);
}



  getToken(): string | undefined {
    console.log(this.getTokenExpiration(this.keycloak.token))
    console.log("this.keycloak => ", this.keycloak)
    return this.keycloak.token;
  }

  getUsername(): string | undefined {
    return this.keycloak.tokenParsed?.preferred_username;
  }

  logout(): void {
    this.keycloak.logout();
  }
}